import React from "react";
import Dashboard from "../dashboard/Dashboard";

export default () => {
  const userString = localStorage.getItem("au");
  const user = JSON.parse(userString) || {};
  return <Dashboard user={user} />;
};
